<template>
  <div class="flex-shop">
    <el-checkbox-group
      v-model="newVenderIds"
      @change="checkShopChange"
    >
      <el-checkbox
        :label="item.venderId"
        v-for="item in shopList"
        :key="item.venderId"
        :disabled="!isSingle&&item.venderId == venderId || isDisabled"
        >{{ item.shopTitle }}</el-checkbox
      >
      <el-tooltip effect="light" placement="top" v-if="isShowTips">
        <template #content>
          <div>1.当前店铺默认勾选，且不可取消勾选；</div>
          <div>2.仅展示当前账号有权限且为同一会员体系下的店铺；</div>
          <div>
            3.多店情况下，①如统计规则为【单笔订单满】则表示用户在任意店铺的一笔订单满足条件即可，比如用户在A店有一笔订单满足条件，B店有两笔订单满足条件，则会根据下单时间选取符合条件中最早的一笔订单；②如统计规则为【累计订单满】则表示用户在任意店铺下单均会被累计，比如用户在A店、B店都有下单，则均会统计在内；
          </div>
        </template>
        <el-button type="text" style="width: 35px">
          <i class="el-icon-question grey-color"></i>
        </el-button>
      </el-tooltip>
    </el-checkbox-group>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { useValidateMultiShopGoods } from "@/views/interactiveMarketing/activity/components/commDataHook/useBasicInformation.js";

export default {
  components: {},
  props: {
    venderIds: {
      type: Array,
      default: () => [],
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    sellerSkuList: {
      type: Array,
      default: () => [],
    },
    multiShopGoods: {
      type: Array,
      default: () => [],
    },
    isSingle: {
      type: Boolean,
      default: false,
    },
    isShowTips: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return { 
      internalVenderIds: [...this.venderIds],
      lastSingleSelected: null // 保存单选模式下最后选中的值，用于取消勾选时恢复
    };
  },
  computed: {
    ...mapState(["shopList"]),
    newVenderIds: {
      get() {
        return this.internalVenderIds;
      },
      set(val) {
        this.internalVenderIds = val;
        this.$emit("update:venderIds", val);
      }
    },
    venderId() {
      // 店铺Id
      return this.$store.getters.loginUserInfo.venderId;
    },
    newSellerSkuList: {
        get() {
            return this.sellerSkuList;
        },
        set(val) {
            this.$emit("update:sellerSkuList", val);
        }
    },
    newMultiShopGoods: {
        get() {
            return this.multiShopGoods;
        },
        set(val) {
            this.$emit("update:multiShopGoods", val);
        }
    },
  },
  watch: {
    venderIds: {
      immediate: true,
      handler(val) {
        this.internalVenderIds = [...val];
        // 初始化单选模式下的最后选中值
        if (this.isSingle && val && val.length > 0) {
          this.lastSingleSelected = val[0];
        }
      }
    }
  },
  mounted() {},
  methods: {
    checkShopChange(shopList) {
      // 单选模式下，只保留最后选择的项，且不允许取消勾选
      let selectedShopList = shopList;
      if (this.isSingle) {
        if (shopList.length === 0) {
          // 不允许取消勾选，恢复到上一次选中的状态
          if (this.lastSingleSelected) {
            this.newVenderIds = [this.lastSingleSelected];
            selectedShopList = [this.lastSingleSelected];
          }
          return;
        }
        if (shopList.length > 1) {
          selectedShopList = [shopList[shopList.length - 1]];
          this.newVenderIds = selectedShopList;
        }
        // 保存当前选中的值
        this.lastSingleSelected = selectedShopList[0];
      }

      this.newMultiShopGoods = useValidateMultiShopGoods(this, selectedShopList);
      // 1. 保存当前已选择的skuIds映射
      const existingSkuMap = new Map();
      this.newSellerSkuList.forEach(item => {
        existingSkuMap.set(item.venderId+'', item.skuIds);
        existingSkuMap.set(item.venderId+'1', item.itemList);
      });

      // 2. 清空现有列表但保留映射关系
      this.newSellerSkuList = [];
      let list = []
      console.log(selectedShopList,'666');
      // 3. 重新添加选中店铺，恢复原有skuIds
      selectedShopList.forEach(venderId => {
        // 查找店铺信息
        const shopInfo = this.shopList.find(shop => shop.venderId == venderId);
        if (shopInfo) {
          list.push({
            venderId: venderId,
            // 恢复已选择的skuIds，新店铺则初始化为空数组
            skuIds: existingSkuMap.get(venderId+'') || [],
            itemList: existingSkuMap.get(venderId+'1') || [],
          });
        }
      });
      this.newSellerSkuList = list;
      console.log(this.newSellerSkuList,'777');
      this.$emit("changeShop",list);
    },
  },
};
</script>
<style lang="scss" scoped>
.flex-shop {
  display: flex;
  flex-wrap: wrap;
}
</style>
